import GraphEntity from "./graphEntity";

class Field extends GraphEntity {
    constructor(field, graph) {
        super(field, graph)
        this.isCalculated = field.id != null || !!field.calculatedField;
        field.queries = field.queries || [];
    }

    applyQueryString(queryString) {
        this.value.queryString = queryString;
        return this;
    }

    hasIndexer() {
        return !!this.value.indexer;
    }

    getIndexer() {
        if (this.hasIndexer()) {
            return this.value.indexer.widgetSystemName;
        }

        return "";
    }

    hasDescendants() {
        const queries = this.value.queries;
        return queries.length > 0 && queries.some(q => q.query.name === "sharedo.descendants");
    }

    hasRelated() {
        const queries = this.value.queries;
        return queries.length > 0 && queries.some(q => q.query.name === "sharedo.related");
    }

    hasSelectableTypes() {
        const queries = this.value.queries;
        return queries.length > 0 && queries.some(q => q.query.widgetSystemName === "Sharedo.Core.Case.DataGraph.FieldQueries.SharedoTypeSpecifier");
    }

    hasDateTimeFormatter() {
        const queries = this.value.queries;
        return queries.length > 0 && queries.some(q => q.query.name === "query.dateTimeFormat");
    }

    hasCurrencyFormatter() {
        const queries = this.value.queries;
        return queries.length > 0 && queries.some(q => q.query.name === "query.currencyFormat");
    }

    hasPercentageFormatter() {
        const queries = this.value.queries;
        const q = queries.find(q => q.query.name === "query.percentageFormat");
        if (!q)
            return false;

        return !q.query.widgetConfig.property && !q.query.widgetConfig.value;
    }

    hasPropertyValueQuery() {
        const queries = this.value.queries;
        return queries.length > 0 && queries.some(q => q.query.widgetSystemName === "Sharedo.Core.Case.DataGraph.FieldQueries.PropertyValueQuery");
    }

    hasBudgetAmountQuery() {
        const queries = this.value.queries;
        return queries.length > 0 && queries.some(q => q.query.name === "query.budgetAmount");
    }

    isResult() {
        return this.value.name === "__result";
    }

    getUnderlyingType() {
        const fieldType = this.value.type;

        if (fieldType.kind === "list") {
            return this._graph.getType(fieldType.ofType.name);
        }

        return this._graph.getType(fieldType.name);
    }

    getType() {
        return this._graph.getType(this.value.type.name);
    }

    typeDisplayName() {
        if (this.isCalculated && !this.value.type.kind !== "list") {
            return "Calculated";
        }

        const type = this._graph.getType(this.value.type.name);
        if (this.value.type.kind !== "list") {
            return type.value.displayName || type.value.name;
        }

        const ofType = this._graph.getType(this.value.type.ofType.name);
        const listName = ofType.value.displayName || ofType.value.name;

        if (!this.isCalculated) {
            return `List of ${listName}`;
        }

        return `Calcuated list of ${listName}`;
    }
}

export default Field;